import request from '../../utils/request'
import qs from 'qs'
import { GETUSERINFO, GETUSERLIST, GETUSERSTATUS } from '../constants'

/**
 * 获取用户列表
 * @param {*} params
 * @returns
 */
export const getUserList = (params, isLoading) => {
  return async (dispatch) => {
    const res = await request.get('sys/comp/user/', {
      params,
      isLoading,
    })
    console.log(res.data.data)
    dispatch({
      type: GETUSERLIST,
      payload: res.data.data,
    })
  }
}

/**
 * 获取用户信息
 * @param {*} id
 * @returns
 */
export const getUserInfo = (id) => {
  return async (dispatch) => {
    const res = await request.get(`sys/comp/user/${id}/`)
    console.log(res)
    dispatch({
      type: GETUSERINFO,
      payload: res.data.data,
    })
  }
}

/**
 * 新增用户
 * @param {*} values
 * @returns
 */
export const addUser = (values) => {
  return async (dispatch) => {
    const res = await request.post('sys/comp/user/', values)
    console.log(res)
    return res
  }
}

/**
 * 修改用户
 * @param {*} values
 * @returns
 */
export const editUser = (values) => {
  return async (dispatch) => {
    const res = await request.put(`sys/comp/user/${values.emp_id}/`, values)
    console.log(res)
    return res
  }
}

/**
 * 删除用户
 * @param {*} id
 * @returns
 */
export const delUsers = (id) => {
  return async (dispatch) => {
    const res = await request.delete(`sys/comp/user/${id}/`)
    console.log(res)
    return res
  }
}

/**
 * 批量删除
 * @param {*} values
 * @returns
 */
export const batchDel = (params) => {
  return async (dispatch) => {
    await request.delete('sys/comp/user/', {
      params,
    })
  }
}

/**
 * 重置密码
 * @param {*} values
 * @returns
 */
export const resetPassword = (values) => {
  return async (dispatch) => {
    const res = await request.post('sys/password/reset/', values)
    console.log(res)
  }
}

export const getTrigger = (params, isLoading) => {
  return async (dispatch) => {
    return await request.get('sys/user/check/', {
      params,
      isLoading,
    })
  }
}

export const switchCoList = () => {
  return async (dispatch) => {
    const res = await request.get('sys/comp/switch/')
    return res
  }
}

export const editPersonalInfo = (params) => {
  return async (dispatch) => {
    const res = await request({
      method: 'patch',
      url: `sys/user/info/`,
      data: params,
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
    })
    console.log(res)
    return res
  }
}

export const logoutComp = (params) => {
  return async (dispatch) => {
    const res = await request.delete('sys/comp/logout/', { data: params })
    console.log(res)
    return res
  }
}

export const editMobile = (values) => {
  return async (dispatch) => {
    const res = await request.put('sys/user/mobile/', values)
    return res
  }
}
export const editEmail = (values) => {
  return async (dispatch) => {
    const res = await request.put('sys/user/email/', values)
    return res
  }
}

export const getWxQcd = (isLoading) => {
  return async (dispatch) => {
    const res = await request.get('sys/user/wechat/', { isLoading })
    return res
  }
}

export const editWechatInfo = (params, isLoading) => {
  return async (dispatch) => {
    const res = await request.get('sys/wechat/info/', {
      params,
      isLoading,
      notMsg: true,
    })
    return res
  }
}

export const getBindStatus = (pollToken, isLoading) => {
  return async (dispatch) => {
    const res = await request.put(
      'sys/polling/',
      { poll_token: pollToken },
      { isLoading, notMsg: true }
    )
    return res
  }
}

export const resetChangeFn = (values, isLoading) => {
  return async (dispatch) => {
    const res = await request.put('sys/comp/user/charge/resume-sync/', values, {
      isLoading,
    })
    return res
  }
}

export const getUserStatus = (params, isLoading) => {
  return async (dispatch) => {
    const res = await request.get('sys/dic/item/', {
      params,
      isLoading,
    })
    dispatch({
      type: GETUSERSTATUS,
      payload: res.data.data.data,
    })
  }
}

export const changeUserStatus = (id, params) => {
  return async (dispatch) => {
    return await request.patch(`sys/comp/user/${id}/`, params)
  }
}
